import { TAppState } from '../../types/appState';

export const agentIdSelector = (state: TAppState) => {
  const { chatWindow, chatList, openedChats } = state;
  const { currentOpenedChatId } = chatWindow;
  const { removedFromArchiveChatId, removedFromSpamChatId } = chatList;

  const chatId = (currentOpenedChatId || removedFromArchiveChatId || removedFromSpamChatId) as string;
  /* istanbul ignore next */
  const chat = openedChats[chatId] || {};
  const { agentId } = chat;

  return agentId || null;
};
